/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DDTAttiviDTO,
  ProblemDetails,
  RapportiniCreateDTO,
  RapportiniDTO,
  RapportiniUpdateDTO,
  RapportinoFileDTO,
  RapportinoInvioDTO,
} from '../models/index';
import {
    DDTAttiviDTOFromJSON,
    DDTAttiviDTOToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    RapportiniCreateDTOFromJSON,
    RapportiniCreateDTOToJSON,
    RapportiniDTOFromJSON,
    RapportiniDTOToJSON,
    RapportiniUpdateDTOFromJSON,
    RapportiniUpdateDTOToJSON,
    RapportinoFileDTOFromJSON,
    RapportinoFileDTOToJSON,
    RapportinoInvioDTOFromJSON,
    RapportinoInvioDTOToJSON,
} from '../models/index';

export interface DeleteRapportinoByIdRequest {
    id: number;
}

export interface FirmaRapportinoRequest {
    rapportinoFileDTO?: RapportinoFileDTO;
}

export interface GeneraRapportinoByIdRequest {
    idRapportino?: number;
}

export interface GetDDTAttiviRequest {
    clienteId?: number;
}

export interface GetEmailsClienteRequest {
    codiceCliente?: string;
}

export interface GetRapportiniRequest {
    daData?: Date;
    aData?: Date;
    personaleId?: number;
}

export interface GetRapportinoByIdRequest {
    idRapportino: number;
}

export interface InsertRapportinoRequest {
    rapportiniCreateDTO?: RapportiniCreateDTO;
}

export interface InvioRapportinoRequest {
    rapportinoInvioDTO?: RapportinoInvioDTO;
}

export interface UpdateRapportinoByIdRequest {
    id: number;
    rapportiniUpdateDTO?: RapportiniUpdateDTO;
}

/**
 * 
 */
export class RapportiniApi extends runtime.BaseAPI {

    /**
     */
    async deleteRapportinoByIdRaw(requestParameters: DeleteRapportinoByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteRapportinoById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/custom/ATS/Rapportini/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteRapportinoById(requestParameters: DeleteRapportinoByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteRapportinoByIdRaw(requestParameters, initOverrides);
    }

    /**
     */
    async firmaRapportinoRaw(requestParameters: FirmaRapportinoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/custom/ATS/Rapportini/firmaRapportino`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RapportinoFileDTOToJSON(requestParameters['rapportinoFileDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async firmaRapportino(requestParameters: FirmaRapportinoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.firmaRapportinoRaw(requestParameters, initOverrides);
    }

    /**
     */
    async generaRapportinoByIdRaw(requestParameters: GeneraRapportinoByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RapportinoFileDTO>> {
        const queryParameters: any = {};

        if (requestParameters['idRapportino'] != null) {
            queryParameters['idRapportino'] = requestParameters['idRapportino'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/custom/ATS/Rapportini/generaRapportinoById`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RapportinoFileDTOFromJSON(jsonValue));
    }

    /**
     */
    async generaRapportinoById(requestParameters: GeneraRapportinoByIdRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RapportinoFileDTO> {
        const response = await this.generaRapportinoByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDDTAttiviRaw(requestParameters: GetDDTAttiviRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DDTAttiviDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['clienteId'] != null) {
            queryParameters['clienteId'] = requestParameters['clienteId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/custom/ATS/Rapportini/getDDTAttivi`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DDTAttiviDTOFromJSON));
    }

    /**
     */
    async getDDTAttivi(requestParameters: GetDDTAttiviRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DDTAttiviDTO>> {
        const response = await this.getDDTAttiviRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getEmailsClienteRaw(requestParameters: GetEmailsClienteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        if (requestParameters['codiceCliente'] != null) {
            queryParameters['codiceCliente'] = requestParameters['codiceCliente'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/custom/ATS/Rapportini/getEmailsCliente`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async getEmailsCliente(requestParameters: GetEmailsClienteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getEmailsClienteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getRapportiniRaw(requestParameters: GetRapportiniRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RapportiniDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['daData'] != null) {
            queryParameters['daData'] = (requestParameters['daData'] as any).toISOString();
        }

        if (requestParameters['aData'] != null) {
            queryParameters['aData'] = (requestParameters['aData'] as any).toISOString();
        }

        if (requestParameters['personaleId'] != null) {
            queryParameters['personaleId'] = requestParameters['personaleId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/custom/ATS/Rapportini`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RapportiniDTOFromJSON));
    }

    /**
     */
    async getRapportini(requestParameters: GetRapportiniRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RapportiniDTO>> {
        const response = await this.getRapportiniRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getRapportinoByIdRaw(requestParameters: GetRapportinoByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RapportiniDTO>> {
        if (requestParameters['idRapportino'] == null) {
            throw new runtime.RequiredError(
                'idRapportino',
                'Required parameter "idRapportino" was null or undefined when calling getRapportinoById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/custom/ATS/Rapportini/{idRapportino}`.replace(`{${"idRapportino"}}`, encodeURIComponent(String(requestParameters['idRapportino']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RapportiniDTOFromJSON(jsonValue));
    }

    /**
     */
    async getRapportinoById(requestParameters: GetRapportinoByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RapportiniDTO> {
        const response = await this.getRapportinoByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async insertRapportinoRaw(requestParameters: InsertRapportinoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/custom/ATS/Rapportini`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RapportiniCreateDTOToJSON(requestParameters['rapportiniCreateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async insertRapportino(requestParameters: InsertRapportinoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.insertRapportinoRaw(requestParameters, initOverrides);
    }

    /**
     */
    async invioRapportinoRaw(requestParameters: InvioRapportinoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/custom/ATS/Rapportini/invioRapportino`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RapportinoInvioDTOToJSON(requestParameters['rapportinoInvioDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async invioRapportino(requestParameters: InvioRapportinoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invioRapportinoRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateRapportinoByIdRaw(requestParameters: UpdateRapportinoByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateRapportinoById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/custom/ATS/Rapportini/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RapportiniUpdateDTOToJSON(requestParameters['rapportiniUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateRapportinoById(requestParameters: UpdateRapportinoByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateRapportinoByIdRaw(requestParameters, initOverrides);
    }

}
